import React from "react"
import { API } from '@stoplight/elements';

require('@stoplight/elements/styles.min.css');
require('/static/styles.css');

export default function Home() {
    return <div>
      <API 
        apiDescriptionUrl="https://docs.sublime.security/openapi/sublime-platform-api.json"
        router={typeof window === 'undefined' ? 'memory' : 'history'} 
      />
    </div>


}
